import React, { useState } from "react";
import Translation from '../../Translation';
import { Tag } from 'antd';
import "./towItemSelectionForm.css"; // Ensure this matches your component

export default function Heatnotburn() {
    // Example state; replace with your actual state management


    return (
        <div>
            <div className="view-heading">
                <h2 className="text-semibold margin-none">
                    <Translation labelName="Heat-Not-Burn" defaultText="Heat Not Burn / Heated Tobacco Products" />
                </h2>
                {/* <a
                    href="/help/html/Tow_Item_Selection.htm"
                    target="_blank"
                    title="Help"
                    className="help-section"
                >
                    <img
                        src="./images/help-inverse-black.svg"
                        alt="help"
                        className="help-icon"
                    />
                </a> */}
            </div>
            <div className="body-inner-text">
                <h2>Introduction to Heat Not Burn (HNB) Products / Heated Tobacco Products (HTP)
                </h2>
                <p>
                    Heat-not-burn (HNB) tobacco products are electronic devices that heat tobacco leaves to produce an inhalable aerosol instead of burning the tobacco like regular cigarettes.<br />
                    HNB products can come in many forms and configurations.<br />
                    They may contain nicotine, additives, and flavorings, and produce an aerosol that's similar in nicotine content to traditional cigarettes.<br />
                    HNB products are different from vape pens.

                </p>

                <h2>Importance of a Correct Tow Item Selection
                </h2>
                <p>
                    Most HNB sticks feature in the filter segment a combination of hollow tube(s) and standard filter(s) to achieve optimal cooling and desired Pressure Drop (EPD).<br />
                    EPD values for HNB filters are typically lower than the conventional cigarette filters.<br />
                    Both hollow acetate and low-EPD filter segments require special tow grades that Celanese has pioneered.
                </p>

                <h2>How can Celanese Help Your HTP Business?
                </h2>
                <p>The Celanese Global Technical Solutions team has vast experience in designing HNB filters and training customers.<br />
                    If you are interested in exploring tow grades selections for your HNB designs, Global Technical Solutions is here to help.
                </p>


                <p>Contact <a href="mailto:towplus.support@celanese.com" className="contact">Celanese Global Technical Solutions</a></p>
            </div>




        </div>
    );
}


// WEBPACK FOOTER //
// ./src/containers/heatnotburn/index.js